<template>
  <div class="fixed bottom-0 top-auto w-full left-0 right-0 text-gray-500">
    <footer class="self-end py-4 text-xs tracking-wider text-center">
      Developed by <a class="font-bold">PURGO</a>.
    </footer>
  </div>
</template>

<script>
export default {
  name: 'BaseCopyright',
}
</script>
